import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonLayoutComponent } from '../../../common/core/common.layout.component';
import { PageConstant } from '../../../../constant/page.constant';
import { LoadGameService } from '../../../../services/load.game.service';
import { BetlimitService } from '../../../../services/betlimit.service';
import { GIInfoService } from '../../../../services/giinfo.service';
import { ErrorPopupService } from '../../../../services/error.popup.service';
import { UtilService } from '../../../../util/UtilService';
import { FirebaseAnalyticsService } from '../../../../services/firebaseanalytics.service';
import { UserService } from '../../../../services/user.service';

@Component({
    templateUrl: '../../../../template/noop.template.html',
    standalone: false
})
export class FC21LayoutComponent
  extends CommonLayoutComponent
  implements OnInit
{
  public giInfoService = inject(GIInfoService);
  public betLimitService = inject(BetlimitService);
  public router = inject(Router);
  public translate = inject(TranslateService);
  public loadGameService = inject(LoadGameService);
  public componentFactoryResolver = inject(ComponentFactoryResolver);
  public viewContainerRef = inject(ViewContainerRef);
  public errorPopupService = inject(ErrorPopupService);
  public utilService = inject(UtilService);
  public firebaseAnalyticsServices = inject(FirebaseAnalyticsService);
  public userService = inject(UserService);

  constructor() {
    super();
    this.pageName = PageConstant.FC21;
    this.currentMenuName = PageConstant.FC21;
    this.gameNameStr = PageConstant.FC21;
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.isLocalEnv) {
      this.fc21Array = this.betLimitService.setFC21Data(
        this.utilService.isDesktopView
      );
    }
    this.loadGameService.removeAllItem();
    this.loadGameService.addItem('2', 'LANG00254');
    this.initGIInfo();
  }

  onFC21TableClick = (event) => {
    this.pageNavigate(PageConstant.FC21TABLES);
  };
}
